import React from 'react';
import './contact.css';
import bgcontact from '../images/bgcontact.webp';
import SocialNetworks from './SocialNetworks.js';
import ArrowRight from './ArrowRights.js';


let iconWhatsapp = `${process.env.PUBLIC_URL}/images/social/whatsapp.svg`;
let iconMail = `${process.env.PUBLIC_URL}/images/social/mail.svg`;
let iconStars = `${process.env.PUBLIC_URL}/images/social/star.svg`;

function Contact() {
  return (
    <section className='contact' style={{ backgroundImage: `url(${bgcontact})` }} name='contact'>
          <div className='content'>
              <div className='flexIndex'>
       
                <p className='subtitles'>Meet <strong>us</strong></p>
                <div className='titles'>
                    <h2>Contact <sub>-</sub></h2>
                    <ArrowRight className="custom-arrow" />
                    <span className='bajada'>Si tenés algún proyecto, o una idea, o simplemente necesitas ayuda,no dudes en contactarnos. <strong>¡Estamos disponibles!</strong></span>
                </div>

                  <div className='colIndex colIndexData'>
                    <div className='contactData flexIndex'>
                        <div className='colIndex'><h3>SOCIAL</h3>
                            <SocialNetworks/>
                        </div>
                        <div className='colIndex'><h3>INDEX®</h3>
                        <ul className='redes flexIndex'>
                            <li><a href='https://api.whatsapp.com/send?phone=541141887434&text=hello%20world'><img width="100%" src={iconWhatsapp} alt='instagram'></img></a></li>
                            <li><a href='mailto:info@estudioindex.com.ar'><img width="100%" src={iconMail} alt='mail'></img></a></li></ul>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
            <div className='copyrightIndex'>
                <p className='city'><p className='address'>MAURE 2945</p>BUENOS AIRES - ARGENTINA <div className='starsMessi flexIndex'>
                  <div className='erosion'></div><i><img src={iconStars} alt='stars'></img></i><i><img src={iconStars} alt='stars'></img></i><i><img src={iconStars} alt='stars'></img></i></div></p>
                
                <div className='programmer'>
                    <p>I'm a <span>&lt;programmer&gt;</span> i have <span>&lt;no life&gt;</span></p>
                </div>
                
                <p>© 2024 Index®.  All rights reserved.</p>
            </div>
      </section>
  );
}
export default Contact;